import { FC } from "react";
import { GoalProgressBar } from "./GoalProgressBar";

interface GoalItemProps {
  title: string;
  subtitle: string;
  progress: number;
  icon?: React.ReactNode;
  imageUrl?: string;
  colorClass: string;
}

export const GoalItem: FC<GoalItemProps> = ({
  title,
  subtitle,
  progress,
  icon,
  imageUrl,
  colorClass,
}) => {
  return (
    <div className="flex items-center gap-4">
      <div className="bg-opacity-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-lg">
        {imageUrl ? (
          <img src={imageUrl} alt={title} className="h-8 w-8 object-contain" />
        ) : (
          icon
        )}
      </div>
      <div className="min-w-0 flex-1">
        <h4 className="text-base font-light break-words text-gray-900">
          {title}
        </h4>
        <p className="truncate overflow-hidden text-xs font-light text-gray-400">
          {subtitle}
        </p>
      </div>
      <div className="flex w-[150px] shrink-0 items-center gap-3">
        <GoalProgressBar progress={progress} colorClass={colorClass} />
        <span className="w-12 text-right text-base font-light text-gray-700">
          {progress}%
        </span>
      </div>
    </div>
  );
};
